import axios from "axios";

const SEDES_URL =
  "https://institutobilinguelasnaciones.com/terapias/backend/sede.php";

/**
 * Obtiene la lista de sedes desde la tabla sede (idsede, sede).
 * @returns {Promise<Array<{variable1: number, variable2: string}>>}
 */
export function fetchSedes() {
  const data = new FormData();
  data.append("boton", "listarSedes");
  const config = { headers: { "Content-Type": "text/html" } };
  return axios.post(SEDES_URL, data, config).then((res) => {
    let dataRes = res.data;
    if (typeof dataRes === "string") {
      try {
        dataRes = JSON.parse(dataRes);
      } catch (e) {
        return [];
      }
    }
    const raw = dataRes && dataRes.variable2;
    const ok = dataRes && (dataRes.variable1 === true || dataRes.variable1 === 1);
    if (!ok || raw == null) return [];
    if (Array.isArray(raw)) return raw;
    if (typeof raw === "object" && raw !== null) return Object.values(raw);
    return [];
  }).catch(() => []);
}
